import { styled } from '@mui/material/styles'
import { Box, Menu, Typography, IconButton } from '@mui/material'
import { tableCss, ulLiCss } from '../../util'
import { MEDIA } from '../../constants'

export const HeadingOuterWrapper = styled(Box)(`
    display: flex;
    flex-direction: column;
    min-width:100%;
    @media (max-width: ${MEDIA.lg}) {
        padding: 20px;
    }
`)

export const HeadingInnerWrapper = styled(Box)(`
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`)

export const ContentWrapper = styled(Box)(`
    min-height:35px;
    display: flex;
    align-items: center;

    & b, & strong {
        font-weight: 600; // 500;
    }
    & p {
        padding-bottom:10px;
    }
    &.insightsExportToPPT {
        // WILL NOT BE USED ..
        .theadTr { background:#f1f1f1;}
        .theadTr td, .tbodyTr td { padding:10px; border:1px #E0E0E0 solid;}
        .tbodyTr td ul{ margin-left:10px;}
    }
`)

export const CardHeading = styled(Box)(`
    font-weight: 400; // 300;
    font-size: 20px;
    line-height: 30px;
    & img {
        cursor:pointer;
    }
    & .headingRte * {
        padding: 0;
    }
`)

export const ButtonBox = styled(Box)(`
    display:flex;
    white-space:nowrap;
    &.buttonList button {
        margin-left: 12px;
    }
    &.graphBtn-tutorial {
      position: relative;
    }
    &.buttonList .tabButtonGroup button {
      margin-left : 0;
    }
    &.buttonList > span {
        display:flex;
    }

    & button.active {
        background: #095BBD;
        border-color: #095BBD;
        & svg path {
            fill: #fff;
        }
    }
`)

export const CardRteContent = styled(Box)(`
    display: flex;
    padding: 0;
    width: 100%;
    overflow-y: scroll;
    flex-direction: column;

    scrollbar-width: none; 
    -ms-overflow-style: none; 
    &::-webkit-scrollbar {
        display: none;
    }

    & hr {
        display:none;
    }
    & ol, & ul {
        margin-left:15px;
    }
    & li {
        position:relative;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #000;
        line-height:18px;
        padding-bottom:5px;
    }
    
    & ul li ul {
        margin-top:5px;
    }

    & > ul > li:last-child:before {
        display:none;
    }

    ${tableCss};
    ${ulLiCss}
    
    & > ul > li {
        padding-bottom:10px;
    }

    &.slide {
        padding: 0 20px 0;
        // padding: 0 20px 0 0;
        // margin-left: 20px;
        width: 100%;
    }


    & .linkagesOuterDiv {
        width: 100%;
        display: flex;
        flex-direction: column;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        padding-bottom: 15px;
        position:relative;

        .linkagesHeaderP {}
        .linkagesLabelDiv {
            width:100%;
            min-height: 40px;
            display: block;
            padding-bottom: 5px;
            font-size: 13px;
            font-weight: 600;
            line-height: 19px;
            padding-right: 45px;
            position: relative;
        }
        
        .linkagesLabelDiv b {position: relative; padding: 0 0 0 20px; width:100%; display:inline-block; }
        
        .linkagesLabelDiv b:before {
            background: url('data:image/svg+xml;utf8,<svg width="13" height="38" viewBox="0 0 13 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.3536 9.35355C12.5488 9.15829 12.5488 8.84171 12.3536 8.64645L9.17157 5.46447C8.97631 5.2692 8.65973 5.2692 8.46447 5.46447C8.2692 5.65973 8.2692 5.97631 8.46447 6.17157L11.2929 9L8.46447 11.8284C8.2692 12.0237 8.2692 12.3403 8.46447 12.5355C8.65973 12.7308 8.97631 12.7308 9.17157 12.5355L12.3536 9.35355ZM1 9V8.5H0.5V9H1ZM1 29H0.5V29.5H1V29ZM12.3536 29.3536C12.5488 29.1583 12.5488 28.8417 12.3536 28.6464L9.17157 25.4645C8.97631 25.2692 8.65973 25.2692 8.46447 25.4645C8.2692 25.6597 8.2692 25.9763 8.46447 26.1716L11.2929 29L8.46447 31.8284C8.2692 32.0237 8.2692 32.3403 8.46447 32.5355C8.65973 32.7308 8.97631 32.7308 9.17157 32.5355L12.3536 29.3536ZM12 9V8.5H1V9V9.5H12V9ZM1 9H0.5V29H1H1.5V9H1ZM1 29V29.5H12V29V28.5H1V29Z" fill="black"/></svg>') 
                no-repeat -1px top;
            content: '';
            width: 16px;
            height: 24px;
            position: absolute;
            left: 0;
            top: 0;
        }
        .linkagesLabelDiv b:first-of-type:before {}
        .linkagesLabelDiv b:first-of-type:after {height: 100%; width: 1px; background: #565656; content: ''; position: absolute; left: 0px; top: 9px;}
        .linkagesLabelDiv b:last-child:before {background-position: -1px bottom; top: -6px;}
        
        .linkagesValueDiv{
            position: absolute;
            top: 0;
            right: 0;
            border: 1px #000 solid;
            border-radius: 50%;
            height: 40px;
            width: 40px;
            background: #fff;
            font-size: 13px;
            font-weight: 600;
            line-height: 40px;
            text-align: center;
        }
        .linkagesInsightDiv{
            padding-top: 5px !important;
            white-space: pre-wrap;
            width: 100% !important;
            font-size: 12px;
            line-height: 16px;
        }
    }
`)

export const Desktop = styled(Box)(`
    display:block;
    @media (max-width: 980px) {
        display:none;
    }
`)

export const Mobile = styled(Box)(`
    display:none;
    @media (max-width: 980px) {
        display:block;
    }
`)

export const SubHeading = styled(Typography)(`
    font-size:16px;
    font-weight: 600; // 500;
`)

export const MenuWrapper = styled(Menu)(`
    display:none;
    & > ul {
        margin-right:10px !important;
    }
    @media (max-width: 980px) {
        display:block;
    }
    & .buttonList {
        padding:10px;
        display:flex;
        flex-direction:column;
    }
    & .buttonList > * {
        margin:5px 0;
        text-align:left;
        justify-content:start;
        width:100%;
    }
`)

export const IconArrowLeftWrapper = styled(Box)(`
    padding: 0 10px 0 5px;
    cursor: pointer;
`)

export const IconCloseOuterWrapper = styled(Box)(`
    position: absolute;
    z-index:1;
    top: 0;
    left: 0;
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: end;
    align-items: center;
    background: #fff;  
`)

export const IconCloseWrapper = styled(Box)(`
    position: absolute;
    z-index:1;
    top: 10px;
    right: 15px;
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    cursor: pointer;
`)

export const InsightsOuterWrapper = styled(Box)(`
    width: 100%;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    position: relative;
    padding-left:20px;
    /* transition: all 2s; // FullScreening */
    
    &:before {
        content: '';
        position: absolute;
        top: -9px;
        right: 7px;
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-bottom: 10px solid #5B92D3;
        border-top: 0;
        z-index: 1;
    }
`)

export const InsightsInnerWrapper = styled(Box)(`
    width: 100%;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow:hidden;
    border:1px #5B92D3 solid;
    border-radius: 4px;
`)

const ButtonUpDownCss = `
    width: 100%;
    height: 40px;
    display: flex;
    border: 0;
    justify-content:center;
    align-items: center;
    cursor: pointer;
    background: #fff;
    
    svg path {
        fill: #242424
    }
    
    &:hover {
      background : #F2F8FF;
      svg path {
        fill : #095BBD;
      }
    }

    &:active {
      background: #E4EEFB;

    svg path {
      stroke: #063D7E;
      }
    }
`

export const ButtonUp = styled('button')(`
    ${ButtonUpDownCss};

    &.btn-top-disabled.top {
        svg path {fill : #ADADAC}
    }

    // background: linear-gradient(180deg, #E1E1E1 0%, transparent 100%);
`)

export const ButtonDown = styled('button')(`
    ${ButtonUpDownCss};

    &.btn-bottom-disabled.bottom {
      svg path {fill : #ADADAC}
    }
    // background: linear-gradient(180deg, transparent 0%, #E1E1E1 100%);
`)

export const ButtonPlaceHolder = styled('div')(`
    ${ButtonUpDownCss};
    cursor: default;
    height: 10px;
`)

export const MenuIconButton = styled(IconButton)(`
  position: absolute;
  right: -10px;
  top: 2px;
  width: 30px;
  height: 30px;
  z-index: 1;
  transform: rotate(180deg);

  &.btnShow {
    right: 0;
    top: 5px;
  }
`)

export const SlideOverlay = styled(Box)(`
    width:100%;
    background: #fff;
    opacity: 0.2;
    height: calc(100% - 40px);
    display: none;
    position: absolute;
    top: 35px;
    left: 0;
    z-index: 1;
`)

export const ExportButtonsWrapper = styled(Box)(`
    position: relative;
    & .BtnExport.active {
        background: transparent;
        border-color : #454545;
        
      svg path {
        fill : #454545 !important;
      }
    }

    & .BtnExport .MuiButton-endIcon {
      margin-left: 2px;
      margin-right : -9px;
    }

`)

export const ExportWrapper = styled(Box)(`
    position: absolute;
    top: 40px;
    right: 0;
    z-index: 1;
    width: 170px;
    background: #fff;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2);

    & button{
        width:100%;
        margin:0;
        padding: 10px 0 10px 20px;
        display: flex;
        justify-content: start;
    }

    & button .MuiButton-startIcon{
        margin-left: 0;
    }

    &.mui-multi-button {
      border-radius: 4px;

      button {
        margin-left : 0;
        border : none;
        font-size: 13px;
      }
    }
`)

export const MenuOuterWrapper = styled(Box)(`
    position: absolute;
    top:65px;
    right: 20px;
    z-index:10;
    width: 280px;
    background: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.16);
    overflow-x:hidden;
    
    & .insightsCloseButton {
      position: absolute;
      top: 5px;
      right: 7px;
    }
`)

export const MenuInnerWrapper = styled(Box)(`
    width:100%;
    padding:12px;
    overflow-y: auto;
    max-height: 350px;
    text-wrap: auto;
`)

export const MenuHeading = styled(Box)(`
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    background: #F6F6F5;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    width: 100%;
    display: block;
    font-size:14px;
    font-weight: 600;
`)
